import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { THEMES } from 'root-constants'
import { PageIdWoofzS3612 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_S3612: Record<
  Exclude<PageIdWoofzS3612, PageIdWoofzS3612.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofzS3612.DOG_BREED_S3_6_12]: {
    progressBar: 'controlled',
    hasHeader: true,
    headerId: HeaderId.TITLE_MENU,
    id: PageId.DOG_BREED_S3_6_12,
  },
  [PageIdWoofzS3612.DOG_AGE_S3_6_12]: {
    progressBar: 'controlled',
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    id: PageId.DOG_AGE_S3_6_12,
  },
  [PageIdWoofzS3612.SHELTER_S3_6_12]: {
    progressBar: 'controlled',
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    id: PageId.SHELTER_S3_6_12,
  },
  [PageIdWoofzS3612.COMMANDS_S3_6_12]: {
    hasHeader: true,
    headerId: HeaderId.BACK_TITLE_MENU,
    progressBar: 'controlled',
    id: PageId.COMMANDS_S3_6_12,
  },
  [PageIdWoofzS3612.SUBSCRIPTIONS_S3_6_12]: {
    hasHeader: false,
    id: PageId.SUBSCRIPTIONS_S3_6_12,
  },
  [PageIdWoofzS3612.CHAT_UPSELL_S3_6_12]: {
    hasHeader: true,
    theme: THEMES.POLICY,
    id: PageId.CHAT_UPSELL_S3_6_12,
  },
  [PageIdWoofzS3612.UPSELL_1_S3_6_12]: {
    hasHeader: true,
    theme: THEMES.POLICY,
    id: PageId.UPSELL_1_S3_6_12,
  },
  [PageIdWoofzS3612.DOWNLOAD_S3_6_12]: {
    hasHeader: true,
    theme: THEMES.POLICY,
    id: PageId.DOWNLOAD_S3_6_12,
  },
}
